/* eslint-disable */
"use client";

import Link from "next/link";
import styles from "./PlaylistCard.module.css";
import { useAudioPlayer } from "@/context/AudioPlayerContext";
import { Star, ListPlus, Share, PlusCircle, Music2 } from "lucide-react";
import { useRef, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { CheckCircle } from "lucide-react";
import CreatePlaylistModal from "./CreatePlaylistModal";
import { Lock, Unlock, Trash2 } from "lucide-react"; // 🔓/🔒 статус и удаление
import { useSession } from "next-auth/react"; // чтобы узнать текущего пользователя
import ConfirmDeleteModal from "./ConfirmDeleteModal"; // модалка подтверждения удаления
import { Info } from "lucide-react";

import AuthPromptModal from "./AuthPromptModal";
import { AlertTriangle } from "lucide-react";

export default function PlaylistCard({
  playlist,
  onPlay,
  type,
  onRemoveFavorite,
  onHistoryRemove,
  ...props
}) {
  const [showMenu, setShowMenu] = useState(false);
  const [showPlaylistMenu, setShowPlaylistMenu] = useState(false);
  const [userPlaylists, setUserPlaylists] = useState<any[]>([]);
  const { data: session, status } = useSession();
  const [showAuthPrompt, setShowAuthPrompt] = useState<null | {
    title: string;
    message: string;
  }>(null);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const shareMenuRef = useRef(null);

  const playlistMenuRef = useRef(null);

  const isOwner =
    type === "userplaylist" && playlist.ownerId === session?.user?.id;
  const [isShared, setIsShared] = useState(playlist.isShared);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeletePlaylist = () => {
    setShowDeleteModal(true);
    setShowMenu(false);
  };
  const handleToggleShare = async () => {
    try {
      const res = await fetch(`/api/userplaylist/${playlist.id}/share`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ isShared: !isShared }),
      });

      if (res.ok) {
        setIsShared(!isShared);
        toast.success(!isShared ? "Playlist shared" : "Playlist unshared");
      } else {
        toast.error("Failed to update sharing status");
      }
    } catch (err) {
      console.error("Share toggle failed:", err);
      toast.error("Error updating sharing status");
    }
  };
  const confirmDelete = async () => {
    try {
      const res = await fetch(`/api/userplaylist/${playlist.id}`, {
        method: "DELETE",
        credentials: "include",
      });

      if (res.ok) {
        toast.success("Playlist deleted successfully");
        window.location.reload(); // или window.location.href = '/' если нужно уйти со страницы
      } else {
        toast.error("Failed to delete playlist");
      }
    } catch (err) {
      console.error("Delete playlist failed:", err);
      toast.error("Error deleting playlist");
    }
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu((prev) => !prev);
    setShowPlaylistMenu(false); // закрываем вложенное меню при повторном открытии основного
  };

  const handleAddToPlaylistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPlaylistMenu((prev) => !prev);
    if (!session) {
      setShowAuthPrompt({
        title: "You are not signed in",
        message: "Please sign in to add tracks to your playlists.",
      });
      return;
    }
    if (!userPlaylists.length) {
      try {
        const res = await fetch("/api/userplaylist/user", {
          credentials: "include",
        });
        const data = await res.json();
        setUserPlaylists(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Ошибка загрузки пользовательских плейлистов:", err);
        setUserPlaylists([]);
      }
    }
  };
  const handleAddTrack = async (userplaylistId: number) => {
    try {
      const body =
        type === "song"
          ? { userplaylistId, songId: playlist.id }
          : { userplaylistId, workId: playlist.id };

      // 👇 сохраняем результат в переменную
      const res = await fetch("/api/userplaylist/add-track", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include",
      });

      if (res.status === 409) {
        toast.error("This track is already in the playlist", {
          icon: <Info color="#ff756b" size={20} strokeWidth={2.5} />,
        });
        return;
      }

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        toast.error(err.error || "Failed to add track");
        return;
      }

      const message =
        type === "song"
          ? "Track added to playlist!"
          : type === "work"
            ? "Work added to playlist!"
            : "Added!";

      toast.success(message);
      setShowPlaylistMenu(false);
      setShowMenu(false);
    } catch (err) {
      console.error("Ошибка добавления трека:", err);
      toast.error("Failed to add track");
    }
  };

  const handleCreatePlaylist = async (title: string) => {
    try {
      const res = await fetch("/api/userplaylist/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title }),
        credentials: "include",
      });
      const newPlaylist = await res.json();
      setUserPlaylists((prev) => [...prev, newPlaylist]);
      await handleAddTrack(newPlaylist.id);
      toast.success("New playlist created and track added!", {
        icon: <CheckCircle color="#ff756b" size={20} strokeWidth={2.5} />,
      });
      setShowCreateModal(false);
      setShowPlaylistMenu(false);
      setShowMenu(false);
    } catch (err) {
      console.error("Ошибка создания пользовательского плейлиста:", err);
      toast.error("Failed to create playlist");
    }
  };
  const [isFavorited, setIsFavorited] = useState(playlist.isFavorited ?? false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const t = event.target as Node;

      const outsideShare =
        !shareMenuRef.current || !shareMenuRef.current.contains(t);

      const outsidePlaylist =
        !playlistMenuRef.current || !playlistMenuRef.current.contains(t);

      if (outsideShare && outsidePlaylist) {
        setShowMenu(false);
        setShowPlaylistMenu(false);
      }
    };

    if (showMenu || showPlaylistMenu) {
      document.addEventListener("click", handleClickOutside); // 👈 click вместо mousedown
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showMenu, showPlaylistMenu]);

  const {
    currentTrack,
    isPlaying,
    pause,
    resume,
    currentPlaylistId, // 👈 добавь
    currentType, // 👈 добавь
  } = useAudioPlayer();

  const handlePlayClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isThisCardPlaying) {
      resume();
      return;
    }

    if (type === "song") {
      // у песни slug из модели song
      const slug = playlist.slug;

      onPlay({
        ...playlist,
        slug,
        audioUrl: `/api/audio/${slug}/${slug}.m3u8`,
        _type: "song",
      });
    } else if (type === "playlist") {
      // у плейлиста slug свой, но треки нужны с song.slug
      onPlay(
        {
          ...playlist,
          playlisttrack: playlist.playlisttrack?.map((pt) => ({
            ...pt,
            song: { ...pt.song, slug: pt.song.slug },
          })),
          _type: "playlist",
        },
        playlist.id,
        "playlist",
      );
    } else if (type === "work") {
      // у work slug из модели work
      onPlay(
        {
          ...playlist,
          playlisttrack: playlist.playlisttrack,
          _type: "work",
        },
        playlist.id,
        "work",
      );
    } else if (type === "userplaylist") {
      // у userplaylist slug свой, треки — userplaylisttrack.song.slug
      onPlay(
        {
          ...playlist,
          playlisttrack: playlist.tracks?.map((t) => ({
            song: { ...t.song, slug: t.song.slug },
          })),
          _type: "userplaylist",
        },
        playlist.id,
        "userplaylist",
      );

      // История пользовательского плейлиста —
      // отдельная таблица и отдельный API
      fetch("/api/userplaylist-history", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userplaylistId: playlist.id }),
        credentials: "include",
      }).catch((err) => {
        console.error(
          "Ошибка записи истории пользовательского плейлиста:",
          err,
        );
      });
    }
  };

  const linkType =
    type === "playlist"
      ? "playlist"
      : type === "userplaylist"
        ? "userplaylist"
        : type === "work"
          ? "work"
          : type === "song"
            ? "song"
            : "song"; // fallback

  if (!["playlist", "userplaylist", "work", "song"].includes(type)) {
    console.warn("⚠️ Неизвестный type в PlaylistCard:", type, playlist);
  }

  const handlePauseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    pause(); // ⏸️ теперь плеер действительно останавливается
  };
  const handleToggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!session) {
      setShowAuthPrompt({
        title: "You are not signed in",
        message: "Please sign in to view your favorites.",
      });
      return;
    }
    try {
      const body: any = {};

      if (type === "playlist") {
        body.playlistId = playlist.id;
      } else if (type === "song") {
        body.songId = playlist.id;
      } else if (type === "work") {
        body.workId = playlist.id;
      } else if (type === "userplaylist") {
        body.userplaylistId = playlist.id;
      }

      const method = isFavorited ? "DELETE" : "POST";

      const res = await fetch("/api/favorite", {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error(`Favorite toggle failed: ${res.status}`);
      }

      // Локально меняем состояние иконки
      setIsFavorited(!isFavorited);

      // Если мы удалили из избранного и есть колбэк — убираем карточку из списка
      if (method === "DELETE" && typeof onRemoveFavorite === "function") {
        onRemoveFavorite(playlist.id, type);
      }
    } catch (err) {
      console.error("Favorite toggle failed:", err);
    }
  };

  const handleShare = () => {
    const shareUrl = `${window.location.origin}/${type}/${playlist.slug}`;

    if (navigator.share) {
      try {
        navigator.share({
          title: playlist.title,
          url: shareUrl,
        });
      } catch (err) {
        console.error("Share failed:", err);
        toast.error("Sharing failed. Please try again.", {
          icon: <AlertTriangle color="#ff9800" size={20} strokeWidth={2.5} />,
        });
      }
    } else {
      // fallback: copy to clipboard or open modal
      toast("Sharing is not supported on this device", {
        icon: <AlertTriangle color="#ff9800" size={20} strokeWidth={2.5} />,
      });
    }
  };

  const isThisCardPlaying =
    isPlaying &&
    ((type === "song" && currentTrack?.id === playlist.id) ||
      (type !== "song" &&
        currentPlaylistId === playlist.id &&
        currentType === type));
  const getCoverSrc = (size: number) => {
    if (!playlist.imageUrl) return "/placeholder.jpg";

    return playlist.imageUrl.replace("/covers/", `/covers/${size}/`);
  };
  return (
    <div className={styles.cardWrapper}>
      <Link href={`/${linkType}/${playlist.slug}`} className={styles.card}>
        {playlist.imageUrl && (
          <div className={styles.imageWrapper}>
            <img
              src={getCoverSrc(440)}
              srcSet={`
    ${getCoverSrc(220)} 220w,
    ${getCoverSrc(440)} 440w
  `}
              sizes="220px"
              alt={playlist.title}
              className={styles.image}
            />
            <button
              className={styles.shareOverlayButton}
              onClick={toggleMenu}
              aria-label="Share"
            >
              <img
                src="/icons/share-new.png"
                alt="Share"
                className={styles.icon}
              />
            </button>

            {isThisCardPlaying ? (
              <button
                className={styles.pauseOverlayButton}
                onClick={handlePauseClick}
                aria-label="Pause"
              >
                <img
                  src="/icons/pause100-new.png"
                  alt="Pause"
                  className={styles.icon}
                />
              </button>
            ) : (
              <button
                className={styles.playOverlayButton}
                onClick={handlePlayClick} // ✅ вот здесь
                aria-label="Play"
              >
                <img
                  src="/icons/play-new.png"
                  alt="Play"
                  className={styles.icon}
                />
              </button>
            )}
          </div>
        )}

        <h2 className={styles.title}>{playlist.title}</h2>
        {type === "userplaylist" && (
          <div className={styles.accessStatus}>
            {isShared ? (
              <>
                <Unlock size={14} className={styles.accessIcon} />
                <span>Public</span>
              </>
            ) : (
              <>
                <Lock size={14} className={styles.accessIcon} />
                <span>Private</span>
              </>
            )}
          </div>
        )}

        {playlist.description && (
          <p className={styles.description}>{playlist.description}</p>
        )}

        {playlist.composer && (
          <p className={styles.description}>{playlist.composer}</p>
        )}
      </Link>

      {showMenu && (
        <div className={styles.shareMenu} ref={shareMenuRef}>
          {(type === "song" || type === "work") && (
            <button onClick={handleAddToPlaylistClick}>
              <ListPlus className={styles.menuIcon} /> Add to Playlist
            </button>
          )}
          <button onClick={(e) => handleToggleFavorite(e)}>
            <Star
              className={`${styles.menuIcon} ${isFavorited ? styles.favorited : ""}`}
            />
            {isFavorited ? "Remove from Favorites" : "Add to Favorites"}
          </button>
          <button onClick={handleShare}>
            <Share className={styles.menuIcon} /> Share
          </button>

          {type === "userplaylist" && isOwner && (
            <button onClick={handleDeletePlaylist}>
              <Trash2 className={styles.menuIcon} /> Delete Playlist
            </button>
          )}

          {type === "userplaylist" && isOwner && (
            <button
              onClick={() => {
                setShowMenu(false);
                handleToggleShare();
              }}
            >
              {isShared ? (
                <Lock className={styles.menuIcon} />
              ) : (
                <Unlock className={styles.menuIcon} />
              )}
              {isShared ? "Make Private" : "Make Public"}
            </button>
          )}

          {onHistoryRemove && (
            <button
              onClick={() => {
                setShowMenu(false);
                onHistoryRemove();
              }}
            >
              <Trash2 className={styles.menuIcon} /> Remove from History
            </button>
          )}
        </div>
      )}

      {showPlaylistMenu && (
        <div className={styles.playlistMenu} ref={playlistMenuRef}>
          {/* ✅ Кнопка создания нового плейлиста — всегда сверху */}
          <button
            onMouseDown={(e) => e.stopPropagation()} // ⛔ блокируем всплытие
            onClick={() => {
              setShowCreateModal(true);
            }}
            className={styles.newPlaylistButton}
          >
            <PlusCircle size={16} /> New Playlist
          </button>

          {/* ✅ Прокручиваемая область со списком плейлистов */}
          <div className={styles.scrollArea}>
            {userPlaylists.map((pl) => (
              <button
                key={pl.id}
                onMouseDown={(e) => e.stopPropagation()} // ⛔ блокируем всплытие
                onClick={() => handleAddTrack(pl.id)}
                className={styles.playlistItem}
              >
                <Music2 size={16} /> {pl.title}
              </button>
            ))}
          </div>
        </div>
      )}

      {showDeleteModal && (
        <ConfirmDeleteModal
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
          playlistTitle={playlist.title}
        />
      )}

      {showCreateModal && (
        <CreatePlaylistModal
          onCreate={handleCreatePlaylist}
          onClose={() => setShowCreateModal(false)}
        />
      )}
      {showAuthPrompt && (
        <AuthPromptModal
          title={showAuthPrompt.title}
          message={showAuthPrompt.message}
          onClose={() => setShowAuthPrompt(null)}
        />
      )}
    </div>
  );
}
